import React from 'react';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button';
import { BulletList, Bullet } from 'components/BulletList';
import OText from 'components/CText/OText';
import './StandardLifeInsuranceOffer.scss';
import classnames from 'classnames';

const StandardLifeInsuranceOffer = props => {
  const { offerMetadata, clickApplyHandler } = props;

  const bullets = offerMetadata?.bullets?.slice(0, 3).map((item, index) => {
    return (
      <Bullet className="text-14 margT8">
        <OText text={item} />
      </Bullet>
    );
  });

  const offerTitleClassDesktop = classnames('t-hide', 'Subtitle-1', {
    secondary_text_light: props?.config?.offerConfigTitle,
    link: props?.config?.offerConfigTitle,
  });

  const offerTitleClassMweb = classnames('d-hide', 'Subtitle-2', {
    secondary_text_light: props?.config?.offerConfigTitle,
  });

  return (
    <>
      {props.seenPixel}
      <FlexContainer className="lifeInsuranceOffer grayShadow16 border-rad8px padL48 padR40 m-padLR16 padTB24 margB16 m-flex-column">
        <FlexContainer className="offerImageContainer justify-center align-items-center">
          <img
            className="offerImage mblock link"
            alt={`${offerMetadata?.displayName} Logo`}
            src={`${offerMetadata?.imageLink}`}
            onClick={clickApplyHandler}
          />
        </FlexContainer>

        <FlexContainer className="offerInfoContainer flex-column m-margT16 margL48 margR24 m-marg0">
          <FlexContainer>
            <div onClick={clickApplyHandler} className={'t-hide Subtitle-1'}>
              {offerMetadata?.title}
            </div>
            <div className={'d-hide Subtitle-2'}>{offerMetadata?.title}</div>
          </FlexContainer>

          <FlexContainer>
            <BulletList className="m-lineHeight-1-4 marg0 system_neutral_n400_text">
              {bullets}
            </BulletList>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer className="buttonContainer justify-center align-items-center flex-column">
          <Button
            mrphType="primary"
            onClick={clickApplyHandler}
            className="applyNowButton m-margT16 border-rad100px"
          >
            <Label
              type="Subtitle-2"
              color="primary_cta_text_light"
              tabIndex="-1"
            >
              Get Quote
            </Label>
          </Button>
          <div className="m-format100 lineHeight-1-33 text-center text-12 system_neutral_n400_text margT8">
            {props?.applyNowLabelText}
          </div>
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

export default StandardLifeInsuranceOffer;
